{
  "title": "Tilføj event",
  "description": "",
  "pages": [
    {
      "name": "page1",
      "title": "Grundoplysninger",
      "description": "",
      "elements": [
        {
          "type": "dropdown",
          "name": "new_edit_copy",
          "visible": false,
          "title": "new_edit_copy",
          "defaultValue": "new",
          "choices": [
            "new",
            "edit",
            "copy"
          ]
        },
        {
          "type": "panel",
          "name": "event_cols",
          "cssClass": "duna-layout duna-cols",
          "titleLocation": "hidden",
          "elements": [
            {
              "type": "panel",
              "name": "event_col_left",
              "cssClass": "duna-layout duna-col",
              "width": "30rem",
              "minWidth": "26rem",
              "elements": [
                {
                  "type": "panel",
                  "name": "card_basics",
                  "title": "Grundoplysninger",
                  "cssClass": "duna-card duna-card--basics",
                  "elements": [
                    {
                      "type": "infomodal",
                      "name": "info_event_type",
                      "title": "Type",
                      "titleLocation": "hidden",
                      "modalTitle": "Type",
                      "infoText": "<p>Vælg hvilken slags event det er. Typen afgør, hvilke felter der er relevante – fx vises prisfelter kun for kurser.</p><p><strong>Øvelse</strong>: en praktisk øvelse. <strong>Kursus</strong>: et kursus, som kan have pris og kunde. <strong>Uddannelse</strong>: et uddannelsesforløb. <strong>Aktivitet</strong>: en øvrig aktivitet eller et arrangement.</p>",
                      "startWithNewLine": true
                    },
                    {
                      "type": "dropdown",
                      "name": "event_type",
                      "title": "Type",
                      "placeholder": "Vælg type…",
                      "width": "10rem",
                      "minWidth": "8.5rem",
                      "isRequired": true,
                      "choices": [
                        {
                          "value": "exercise",
                          "text": "Øvelse"
                        },
                        {
                          "value": "course",
                          "text": "Kursus"
                        },
                        {
                          "value": "education",
                          "text": "Uddannelse"
                        },
                        {
                          "value": "activity",
                          "text": "Aktivitet"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_event_category",
                      "title": "Kategori",
                      "titleLocation": "hidden",
                      "modalTitle": "Kategori",
                      "infoText": "<p>Valgfri. Kategorien giver eventet en farve i kalenderen, så det er nemt at skelne fra andre events.</p><p>Vælg <em>Ingen kategori</em>, hvis eventet ikke skal have en særlig farve.</p>",
                      "visibilityDataSource": "event_category_field_visible",
                      "startWithNewLine": false
                    },
                    {
                      "type": "dropdown",
                      "name": "event_category",
                      "title": "Kategori",
                      "width": "10rem",
                      "minWidth": "8.5rem",
                      "startWithNewLine": false,
                      "defaultValue": "__event_category_none__",
                      "visibilityDataSource": "event_category_field_visible",
                      "allowClear": false,
                      "dataSource": "event_category_choices",
                      "dataSourceKeyField": "text",
                      "dataSourceValueField": "value",
                      "mergeWithStaticChoices": true,
                      "choices": [
                        {
                          "value": "__event_category_none__",
                          "text": "Ingen kategori"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_destination_period",
                      "title": "Destinationsperiode",
                      "titleLocation": "hidden",
                      "modalTitle": "Destinationsperiode",
                      "infoText": "<p>Bestemmer hvilken destinationsperiode eventet tæller med i ved kompetenceafklaring.</p><p><strong>Nuværende periode</strong>: tæller kun i den igangværende periode. <strong>Sidste periode</strong>: tæller i den forrige periode. <strong>Begge perioder</strong>: tæller i begge.</p>",
                      "startWithNewLine": false
                    },
                    {
                      "type": "dropdown",
                      "name": "destination_period",
                      "title": "Destinationsperiode",
                      "width": "13rem",
                      "minWidth": "11rem",
                      "startWithNewLine": false,
                      "defaultValue": "current_period",
                      "choices": [
                        {
                          "value": "current_period",
                          "text": "Nuværende periode"
                        },
                        {
                          "value": "last_period",
                          "text": "Sidste periode"
                        },
                        {
                          "value": "both_periods",
                          "text": "Begge perioder"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_short_description",
                      "title": "Kort beskrivelse",
                      "titleLocation": "hidden",
                      "modalTitle": "Kort beskrivelse",
                      "infoText": "<p>Vises som eventets titel i kalenderen og i oversigter. Hold den kort og sigende.</p>",
                      "startWithNewLine": true
                    },
                    {
                      "type": "text",
                      "name": "short_description",
                      "title": "Kort beskrivelse",
                      "width": "100%",
                      "startWithNewLine": true,
                      "isRequired": true
                    },
                    {
                      "type": "infomodal",
                      "name": "info_description",
                      "title": "Beskrivelse",
                      "titleLocation": "hidden",
                      "modalTitle": "Beskrivelse",
                      "infoText": "<p>Den fulde beskrivelse, som deltagerne ser på eventets informationsside. Beskriv indhold, målgruppe og evt. forudsætninger.</p>",
                      "startWithNewLine": true
                    },
                    {
                      "type": "comment",
                      "name": "description",
                      "title": "Beskrivelse",
                      "width": "100%",
                      "rows": 3,
                      "autoGrow": true,
                      "startWithNewLine": true,
                      "isRequired": true
                    }
                  ]
                },
                {
                  "type": "panel",
                  "name": "card_location",
                  "title": "Sted",
                  "cssClass": "duna-card duna-card--location",
                  "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                  "elements": [
                    {
                      "type": "dropdown",
                      "name": "location",
                      "title": "Lokation",
                      "placeholder": "Vælg lokation…",
                      "width": "14rem",
                      "minWidth": "10rem",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "isRequired": true,
                      "requiredIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "dataSource": "locations",
                      "dataSourceKeyField": "locations_name",
                      "dataSourceValueField": "guid",
                      "mergeWithStaticChoices": true,
                      "onChangeUpdateQuestion": "room",
                      "choices": [
                        {
                          "value": "manual",
                          "text": "Manuel"
                        }
                      ]
                    },
                    {
                      "type": "dropdown",
                      "name": "room",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} notempty and {location} <> 'manual'",
                      "title": "Lokale",
                      "placeholder": "Vælg lokale…",
                      "width": "14rem",
                      "minWidth": "10rem",
                      "startWithNewLine": false,
                      "isRequired": false,
                      "requiredIf": "{manual_room_capacity} empty",
                      "dataSource": "locations_rooms",
                      "dataSourceKeyField": "room_name",
                      "dataSourceValueField": "guid"
                    },
                    {
                      "type": "infomodal",
                      "name": "info_manual_room_capacity",
                      "title": "Manuelt antal pladser",
                      "titleLocation": "hidden",
                      "modalTitle": "Manuelt antal pladser",
                      "infoText": "<p>Angiv selv det maksimale antal deltagere, når der ikke er valgt et konkret lokale. Feltet er påkrævet, hvis intet lokale er valgt.</p><p>Er et lokale valgt, bruges lokalets kapacitet i stedet.</p>",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} notempty",
                      "startWithNewLine": false
                    },
                    {
                      "type": "text",
                      "name": "manual_room_capacity",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} notempty",
                      "title": "Manuelt antal pladser",
                      "width": "11rem",
                      "minWidth": "9rem",
                      "startWithNewLine": false,
                      "requiredIf": "{room} empty",
                      "inputType": "number"
                    },
                    {
                      "type": "panel",
                      "name": "manual_location_group",
                      "title": "Manuel lokation",
                      "cssClass": "duna-subgroup",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} = 'manual'",
                      "startWithNewLine": true,
                      "elements": [
                        {
                          "type": "text",
                          "name": "manual_location",
                          "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} = 'manual'",
                          "title": "Navn",
                          "width": "14rem",
                          "minWidth": "10rem",
                          "isRequired": true
                        },
                        {
                          "type": "text",
                          "name": "manual_location_address",
                          "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} = 'manual'",
                          "title": "Adresse",
                          "width": "14rem",
                          "minWidth": "10rem",
                          "startWithNewLine": false,
                          "isRequired": true
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_additional_rooms",
                      "title": "Ekstra lokaler",
                      "titleLocation": "hidden",
                      "modalTitle": "Ekstra lokaler",
                      "infoText": "<p>Valgfrit. Tilføj flere lokaler fra samme lokation, hvis eventet fylder mere end ét lokale. Hvert ekstra lokale bookes sammen med hovedlokalet.</p>",
                      "visibilityDataSource": "event_additional_rooms_field_visible",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} notempty and {location} <> 'manual' and {room} notempty",
                      "startWithNewLine": true
                    },
                    {
                      "type": "paneldynamic",
                      "name": "additional_rooms",
                      "title": "Ekstra lokaler",
                      "cssClass": "duna-paneldynamic",
                      "width": "100%",
                      "startWithNewLine": true,
                      "visibilityDataSource": "event_additional_rooms_field_visible",
                      "visibleIf": "({schedule_mode} <> 'multi_dates' or {schedule_mode} empty) and {location} notempty and {location} <> 'manual' and {room} notempty",
                      "templateElements": [
                        {
                          "type": "dropdown",
                          "name": "primary_extra_room",
                          "title": "Lokale",
                          "placeholder": "Vælg lokale…",
                          "width": "100%",
                          "isRequired": true,
                          "dataSource": "locations_rooms",
                          "dataSourceKeyField": "room_name",
                          "dataSourceValueField": "guid",
                          "onChangeUpdateQuestion": "location"
                        }
                      ],
                      "templateTitle": "Ekstra lokale {panelIndex}",
                      "addPanelText": "Tilføj ekstra lokale",
                      "removePanelText": "Fjern"
                    }
                  ]
                }
              ]
            },
            {
              "type": "panel",
              "name": "event_col_right",
              "cssClass": "duna-layout duna-col",
              "width": "30rem",
              "minWidth": "26rem",
              "startWithNewLine": false,
              "elements": [
                {
                  "type": "panel",
                  "name": "card_time",
                  "title": "Tid",
                  "cssClass": "duna-card duna-card--time",
                  "elements": [
                    {
                      "type": "infomodal",
                      "name": "info_schedule_mode",
                      "title": "Planlægning",
                      "titleLocation": "hidden",
                      "modalTitle": "Planlægning",
                      "infoText": "<p><strong>Start og slut</strong>: Eventet er én enkelt dag eller én sammenhængende periode. Du angiver start og slut, og kan tilføje yderligere datoer.</p><p><strong>Serieplanlægger</strong>: Du planlægger mange datoer på én gang med samme tid, lokation og moduler. Datoer, tid og lokation vælges i serieplanlæggeren i stedet for under Sted og Tid.</p>",
                      "startWithNewLine": true
                    },
                    {
                      "type": "radiogroup",
                      "name": "schedule_mode",
                      "title": "Planlægning",
                      "cssClass": "duna-segmented",
                      "width": "100%",
                      "colCount": 0,
                      "defaultValue": "period",
                      "choices": [
                        {
                          "value": "period",
                          "text": "Start og slut"
                        },
                        {
                          "value": "multi_dates",
                          "text": "Serieplanlægger"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_schedule_period",
                      "title": "Periode og datoer",
                      "titleLocation": "hidden",
                      "modalTitle": "Periode og datoer",
                      "infoPartnerQuestion": "start_date",
                      "infoText": "<p>Angiv hvornår begivenheden starter og slutter.</p><p><strong>Samme dag</strong> = én session. <strong>Forskellige dage</strong> = ét sammenhængende event over perioden (én tilmelding dækker hele perioden).</p>",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "startWithNewLine": true
                    },
                    {
                      "type": "panel",
                      "name": "period_datetime_group",
                      "cssClass": "duna-layout duna-datetime-pair",
                      "title": "Periode",
                      "titleLocation": "hidden",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "startWithNewLine": true,
                      "elements": [
                        {
                          "type": "text",
                          "name": "start_date",
                          "title": "Start",
                          "width": "13rem",
                          "minWidth": "11.5rem",
                          "isRequired": true,
                          "requiredIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                          "inputType": "datetime-local",
                          "defaultDateTime": "12:00",
                          "startWithNewLine": true
                        },
                        {
                          "type": "text",
                          "name": "end_date",
                          "title": "Slut",
                          "width": "13rem",
                          "minWidth": "11.5rem",
                          "isRequired": true,
                          "requiredIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                          "inputType": "datetime-local",
                          "defaultDateTime": "13:00",
                          "startWithNewLine": false
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_additional_dates",
                      "title": "Yderligere datoer",
                      "titleLocation": "hidden",
                      "modalTitle": "Yderligere datoer",
                      "infoText": "<p>Tilføj ekstra sessioner på andre datoer, hvis begivenheden ikke kun er én dag eller én sammenhængende periode.</p><p>Den første session er altid start- og slutdato ovenfor — du tilføjer kun <em>ekstra</em> datoer her. Feltet er valgfrit.</p><p>For hver dato kan du vælge tid, samme eller anden lokation som forrige dag og evt. forplejning. Under <em>Ekstra lokaler</em> kan du tilføje flere lokaler fra samme lokation for den pågældende dato.</p>",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "startWithNewLine": true
                    },
                    {
                      "type": "paneldynamic",
                      "name": "additional_dates",
                      "title": "Yderligere datoer",
                      "cssClass": "duna-paneldynamic",
                      "width": "100%",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "startWithNewLine": true,
                      "templateElements": [
                        {
                          "type": "text",
                          "name": "sub_event_guid",
                          "visible": false,
                          "title": "Sub-event GUID"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_date",
                          "width": "10rem",
                          "minWidth": "8.5rem",
                          "title": "Dato",
                          "isRequired": true,
                          "inputType": "date"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_start_time",
                          "width": "8.5rem",
                          "minWidth": "7.5rem",
                          "startWithNewLine": false,
                          "title": "Starttid",
                          "isRequired": true,
                          "inputType": "time",
                          "defaultValue": "12:00"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_end_time",
                          "width": "8.5rem",
                          "minWidth": "7.5rem",
                          "startWithNewLine": false,
                          "title": "Sluttid",
                          "isRequired": true,
                          "inputType": "time",
                          "defaultValue": "13:00"
                        },
                        {
                          "type": "boolean",
                          "name": "same_as_previous",
                          "title": "Samme lokation som forrige dag",
                          "titleLocation": "hidden",
                          "labelTrue": "Samme lokation som forrige",
                          "labelFalse": "Anden lokation",
                          "renderAs": "radio",
                          "cssClass": "duna-segmented duna-segmented--compact",
                          "width": "24rem",
                          "minWidth": "16rem",
                          "startWithNewLine": true,
                          "defaultValue": true
                        },
                        {
                          "type": "boolean",
                          "name": "same_catering_as_previous",
                          "visibilityDataSource": "event_catering_field_visible",
                          "title": "Samme forplejning som forrige dag",
                          "titleLocation": "hidden",
                          "labelTrue": "Samme forplejning som forrige",
                          "labelFalse": "Anden forplejning",
                          "renderAs": "radio",
                          "cssClass": "duna-segmented duna-segmented--compact",
                          "width": "24rem",
                          "minWidth": "16rem",
                          "startWithNewLine": false,
                          "defaultValue": true
                        },
                        {
                          "type": "dropdown",
                          "name": "sub_event_location",
                          "visibleIf": "{panel.same_as_previous} <> true",
                          "title": "Lokation",
                          "placeholder": "Vælg lokation…",
                          "requiredIf": "{panel.same_as_previous} <> true",
                          "startWithNewLine": true,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "dataSource": "locations",
                          "dataSourceKeyField": "locations_name",
                          "dataSourceValueField": "guid",
                          "mergeWithStaticChoices": true,
                          "onChangeUpdateQuestion": "sub_event_room",
                          "choices": [
                            {
                              "value": "manual",
                              "text": "Manuel"
                            }
                          ]
                        },
                        {
                          "type": "dropdown",
                          "name": "sub_event_room",
                          "visibleIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} notempty and {panel.sub_event_location} <> 'manual'",
                          "title": "Lokale",
                          "placeholder": "Vælg lokale…",
                          "startWithNewLine": false,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "dataSource": "locations_rooms",
                          "dataSourceKeyField": "room_name",
                          "dataSourceValueField": "guid"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_manual_room_capacity",
                          "visibleIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} notempty",
                          "title": "Manuelt antal pladser",
                          "startWithNewLine": false,
                          "width": "11rem",
                          "minWidth": "9rem",
                          "requiredIf": "{panel.sub_event_room} empty",
                          "inputType": "number"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_manual_location",
                          "visibleIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} = 'manual'",
                          "title": "Manuel lokation - Navn",
                          "startWithNewLine": true,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "requiredIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} = 'manual'"
                        },
                        {
                          "type": "text",
                          "name": "sub_event_manual_location_address",
                          "visibleIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} = 'manual'",
                          "title": "Manuel lokation - Adresse",
                          "startWithNewLine": false,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "requiredIf": "{panel.same_as_previous} <> true and {panel.sub_event_location} = 'manual'"
                        },
                        {
                          "type": "dropdown",
                          "name": "sub_event_catering",
                          "visibilityDataSource": "event_catering_field_visible",
                          "visibleIf": "{panel.same_catering_as_previous} <> true",
                          "title": "Forplejning",
                          "placeholder": "Vælg forplejning…",
                          "requiredIf": "{panel.same_catering_as_previous} <> true",
                          "startWithNewLine": true,
                          "width": "100%",
                          "choices": [
                            {
                              "value": "selv",
                              "text": "Arrangør står selv for forplejning"
                            },
                            {
                              "value": "lokation",
                              "text": "Uddannelsesadministration står for forplejning"
                            },
                            {
                              "value": "irrelevant",
                              "text": "Ingen forplejning"
                            }
                          ]
                        },
                        {
                          "type": "paneldynamic",
                          "name": "sub_event_additional_rooms",
                          "title": "Ekstra lokaler",
                          "cssClass": "duna-paneldynamic duna-paneldynamic--nested",
                          "width": "100%",
                          "visibilityDataSource": "event_additional_rooms_field_visible",
                          "visibleIf": "({panel.same_as_previous} = true or ({panel.sub_event_location} notempty and {panel.sub_event_location} <> 'manual')) and ({panel.same_as_previous} = true or {panel.sub_event_room} notempty)",
                          "templateElements": [
                            {
                              "type": "dropdown",
                              "name": "sub_extra_room",
                              "title": "Lokale",
                              "placeholder": "Vælg lokale…",
                              "width": "100%",
                              "isRequired": true,
                              "dataSource": "locations_rooms",
                              "dataSourceKeyField": "room_name",
                              "dataSourceValueField": "guid",
                              "onChangeUpdateQuestion": "sub_event_location"
                            }
                          ],
                          "templateTitle": "Ekstra lokale {panelIndex}",
                          "addPanelText": "Tilføj ekstra lokale",
                          "removePanelText": "Fjern"
                        }
                      ],
                      "templateTitle": "Dato {panelIndex}",
                      "addPanelText": "Tilføj dato",
                      "removePanelText": "Slet dato"
                    },
                    {
                      "type": "infomodal",
                      "name": "info_series_share_participants",
                      "title": "Deltagere på tværs af datoer",
                      "titleLocation": "hidden",
                      "modalTitle": "Deltagere på tværs af datoer",
                      "infoText": "<p><strong>Kun på tilmeldt dag</strong> (standard): Deltagere tilmelder sig den konkrete dato de vælger — hver dato kan have sit eget antal deltagere.</p><p><strong>Gælder alle dage</strong>: Én tilmelding dækker alle sessioner i serien (underbegivenheder).</p><p>Valget gælder kun, når eventet har flere datoer.</p>",
                      "visibleIf": "{additional_dates} notempty or {series_planner_active} = 'true'",
                      "startWithNewLine": true
                    },
                    {
                      "type": "radiogroup",
                      "name": "series_share_participants",
                      "title": "Deltagere på tværs af datoer",
                      "cssClass": "duna-segmented",
                      "width": "100%",
                      "colCount": 0,
                      "visibleIf": "{additional_dates} notempty or {series_planner_active} = 'true'",
                      "isRequired": true,
                      "defaultValue": "false",
                      "choices": [
                        {
                          "value": "false",
                          "text": "Kun den tilmeldte dag"
                        },
                        {
                          "value": "true",
                          "text": "Alle dage i serien"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_series_exceptions",
                      "title": "Undtagelser",
                      "titleLocation": "hidden",
                      "modalTitle": "Undtagelser",
                      "infoText": "<p>Valgfrie afvigelser: ingen session på en dato, eller afvigende tid/lokation.</p><p>Gælder ved sammenhængende periode over flere dage eller ved serieplanlægning med flere datoer.</p><p>Lader du start-/sluttid eller lokation stå tom, bruges eventets standard. Under <em>Ekstra lokaler</em> kan du tilføje flere lokaler for netop denne undtagelse.</p>",
                      "visibleIf": "{schedule_inferred_mode} = 'multi_day' and ({schedule_mode} <> 'multi_dates' or {schedule_mode} empty)",
                      "startWithNewLine": true
                    },
                    {
                      "type": "paneldynamic",
                      "name": "series_exceptions",
                      "visibleIf": "{schedule_inferred_mode} = 'multi_day' and ({schedule_mode} <> 'multi_dates' or {schedule_mode} empty)",
                      "title": "Undtagelser",
                      "cssClass": "duna-paneldynamic",
                      "width": "100%",
                      "startWithNewLine": true,
                      "templateElements": [
                        {
                          "type": "text",
                          "name": "exception_sub_event_guid",
                          "visible": false,
                          "title": "Sub-event GUID"
                        },
                        {
                          "type": "text",
                          "name": "exception_date",
                          "title": "Dato",
                          "width": "10rem",
                          "minWidth": "8.5rem",
                          "isRequired": true,
                          "inputType": "date"
                        },
                        {
                          "type": "text",
                          "name": "exception_start_time",
                          "visibleIf": "{panel.exception_skip} <> true",
                          "title": "Starttid",
                          "width": "8.5rem",
                          "minWidth": "7.5rem",
                          "startWithNewLine": false,
                          "inputType": "time"
                        },
                        {
                          "type": "text",
                          "name": "exception_end_time",
                          "visibleIf": "{panel.exception_skip} <> true",
                          "title": "Sluttid",
                          "width": "8.5rem",
                          "minWidth": "7.5rem",
                          "startWithNewLine": false,
                          "inputType": "time"
                        },
                        {
                          "type": "boolean",
                          "name": "exception_skip",
                          "title": "Ingen session denne dato",
                          "titleLocation": "hidden",
                          "labelTrue": "Ingen session denne dato",
                          "labelFalse": "Session afholdes",
                          "renderAs": "radio",
                          "cssClass": "duna-segmented duna-segmented--compact",
                          "width": "20rem",
                          "minWidth": "14rem",
                          "startWithNewLine": true
                        },
                        {
                          "type": "dropdown",
                          "name": "exception_location",
                          "visibleIf": "{panel.exception_skip} <> true",
                          "title": "Lokation",
                          "placeholder": "Standard",
                          "startWithNewLine": true,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "dataSource": "locations",
                          "dataSourceKeyField": "locations_name",
                          "dataSourceValueField": "guid",
                          "mergeWithStaticChoices": true,
                          "onChangeUpdateQuestion": "exception_room",
                          "choices": [
                            {
                              "value": "manual",
                              "text": "Manuel"
                            }
                          ]
                        },
                        {
                          "type": "dropdown",
                          "name": "exception_room",
                          "visibleIf": "{panel.exception_skip} <> true and {panel.exception_location} notempty and {panel.exception_location} <> 'manual'",
                          "title": "Lokale",
                          "placeholder": "Vælg lokale…",
                          "startWithNewLine": false,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "dataSource": "locations_rooms",
                          "dataSourceKeyField": "room_name",
                          "dataSourceValueField": "guid"
                        },
                        {
                          "type": "text",
                          "name": "exception_manual_room_capacity",
                          "visibleIf": "{panel.exception_skip} <> true and {panel.exception_location} notempty",
                          "title": "Manuelt antal pladser",
                          "startWithNewLine": false,
                          "width": "11rem",
                          "minWidth": "9rem",
                          "requiredIf": "{panel.exception_room} empty and {panel.exception_location} notempty",
                          "inputType": "number"
                        },
                        {
                          "type": "text",
                          "name": "exception_manual_location",
                          "visibleIf": "{panel.exception_skip} <> true and {panel.exception_location} = 'manual'",
                          "title": "Manuel lokation - Navn",
                          "startWithNewLine": true,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "requiredIf": "{panel.exception_location} = 'manual'"
                        },
                        {
                          "type": "text",
                          "name": "exception_manual_location_address",
                          "visibleIf": "{panel.exception_skip} <> true and {panel.exception_location} = 'manual'",
                          "title": "Manuel lokation - Adresse",
                          "startWithNewLine": false,
                          "width": "14rem",
                          "minWidth": "10rem",
                          "requiredIf": "{panel.exception_location} = 'manual'"
                        },
                        {
                          "type": "paneldynamic",
                          "name": "exception_additional_rooms",
                          "title": "Ekstra lokaler",
                          "cssClass": "duna-paneldynamic duna-paneldynamic--nested",
                          "width": "100%",
                          "visibilityDataSource": "event_additional_rooms_field_visible",
                          "visibleIf": "{panel.exception_skip} <> true and {panel.exception_location} notempty and {panel.exception_location} <> 'manual' and {panel.exception_room} notempty",
                          "templateElements": [
                            {
                              "type": "dropdown",
                              "name": "exception_extra_room",
                              "title": "Lokale",
                              "placeholder": "Vælg lokale…",
                              "width": "100%",
                              "isRequired": true,
                              "dataSource": "locations_rooms",
                              "dataSourceKeyField": "room_name",
                              "dataSourceValueField": "guid",
                              "onChangeUpdateQuestion": "exception_location"
                            }
                          ],
                          "templateTitle": "Ekstra lokale {panelIndex}",
                          "addPanelText": "Tilføj ekstra lokale",
                          "removePanelText": "Fjern"
                        }
                      ],
                      "templateTitle": "Undtagelse {panelIndex}",
                      "addPanelText": "Tilføj undtagelse",
                      "removePanelText": "Slet undtagelse"
                    }
                  ]
                },
                {
                  "type": "panel",
                  "name": "card_access",
                  "title": "Tilgængelighed og ressourcer",
                  "cssClass": "duna-card duna-card--access",
                  "elements": [
                    {
                      "type": "infomodal",
                      "name": "info_visibility",
                      "title": "Tilgængelighed",
                      "titleLocation": "hidden",
                      "modalTitle": "Tilgængelighed",
                      "infoText": "<p><strong>Egen organisation</strong>: Eventet er kun synligt for brugere i jeres egen organisation. Tilmelding kræver login.</p><p><strong>Åben for alle / Offentlig</strong>: Eventet kan ses og tilmeldes af eksterne deltagere uden at være logget ind. Vælg denne indstilling, når begivenheden skal være åben for tilmelding uden for organisationen.</p>"
                    },
                    {
                      "type": "dropdown",
                      "name": "visibility",
                      "title": "Tilgængelighed",
                      "width": "15rem",
                      "minWidth": "11rem",
                      "startWithNewLine": false,
                      "defaultValue": "private",
                      "isRequired": true,
                      "allowClear": false,
                      "choices": [
                        {
                          "value": "private",
                          "text": "Egen organisation"
                        },
                        {
                          "value": "public",
                          "text": "Åben for alle / Offentlig"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_catering",
                      "title": "Forplejning",
                      "visibilityDataSource": "event_catering_field_visible",
                      "titleLocation": "hidden",
                      "modalTitle": "Forplejning",
                      "infoText": "<p><strong>Arrangør står selv for forplejning</strong>: I håndterer mad og drikke selv. Eventet vises ikke i catering-modulet.</p><p><strong>Uddannelsesadministration står for forplejning</strong>: Vælg dette, hvis uddannelsesadministrationen skal bestille forplejning. Eventet dukker op i catering-modulet, og deltagere kan angive kostpræferencer ved tilmelding.</p><p><strong>Ingen forplejning</strong>: Der er ingen forplejning tilknyttet eventet.</p>",
                      "startWithNewLine": false
                    },
                    {
                      "type": "dropdown",
                      "name": "catering",
                      "title": "Forplejning",
                      "placeholder": "Vælg forplejning…",
                      "width": "20rem",
                      "minWidth": "12rem",
                      "startWithNewLine": false,
                      "visibilityDataSource": "event_catering_field_visible",
                      "isRequired": true,
                      "choices": [
                        {
                          "value": "selv",
                          "text": "Arrangør står selv for forplejning"
                        },
                        {
                          "value": "lokation",
                          "text": "Uddannelsesadministration står for forplejning"
                        },
                        {
                          "value": "irrelevant",
                          "text": "Ingen forplejning"
                        }
                      ]
                    },
                    {
                      "type": "infomodal",
                      "name": "info_organization_resource_ids",
                      "title": "Ressourcer",
                      "titleLocation": "hidden",
                      "modalTitle": "Ressourcer",
                      "infoText": "<p>Valgfrit. Vælg de bookbare ressourcer (fx udstyr eller køretøjer), som eventet skal bruge. De reserveres, mens eventet løber.</p>",
                      "visibilityDataSource": "event_org_resources_field_visible",
                      "startWithNewLine": true
                    },
                    {
                      "type": "tagbox",
                      "name": "organization_resource_ids",
                      "title": "Ressourcer",
                      "placeholder": "Vælg ressourcer…",
                      "width": "100%",
                      "startWithNewLine": true,
                      "visibilityDataSource": "event_org_resources_field_visible",
                      "dataSource": "event_org_resources",
                      "dataSourceKeyField": "label",
                      "dataSourceValueField": "id",
                      "searchEnabled": true,
                      "allowClear": true
                    },
                    {
                      "type": "panel",
                      "name": "event_materials_panel",
                      "title": "Materiel (valgfrit)",
                      "cssClass": "duna-subgroup duna-subgroup--collapsible duna-event-materials-panel",
                      "state": "collapsed",
                      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
                      "visibilityDataSource": "duna_materials_enabled",
                      "startWithNewLine": true,
                      "elements": [
                        {
                          "type": "infomodal",
                          "name": "info_event_materials",
                          "title": "Materiel",
                          "titleLocation": "hidden",
                          "modalTitle": "Materiel og ledighed",
                          "infoText": "<p>Vælg materiel nedenfor. Grønne datoer i kalenderen viser ledige dage for det valgte antal. Klik en ledig dato for at opdatere start- og slutdato.</p>"
                        },
                        {
                          "type": "eventmaterialplanner",
                          "name": "event_material_planner",
                          "title": "Materiel til eventet",
                          "titleLocation": "hidden",
                          "width": "100%"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "card_series",
          "title": "Datoer og sessioner",
          "cssClass": "duna-card duna-card--series",
          "visibleIf": "{schedule_mode} = 'multi_dates'",
          "startWithNewLine": true,
          "elements": [
            {
              "type": "infomodal",
              "name": "info_card_series",
              "title": "Datoer og sessioner",
              "titleLocation": "hidden",
              "modalTitle": "Datoer og sessioner",
              "infoPartnerQuestion": "card_series",
              "infoText": "<p>Her planlægger du mange datoer på én gang. Alle datoer får samme tid, lokation og moduler som på de andre sider, medmindre du angiver undtagelser for enkelte dage.</p>",
              "startWithNewLine": true
            },
            {
              "type": "eventseriesplanner",
              "name": "event_series_planner",
              "title": "Datoer og sessioner",
              "titleLocation": "hidden",
              "width": "100%",
              "visibleIf": "{schedule_mode} = 'multi_dates'",
              "startWithNewLine": true
            }
          ]
        },
        {
          "type": "text",
          "name": "series_planner_active",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_planning_mode",
          "visible": false,
          "defaultValue": "standard_with_exceptions"
        },
        {
          "type": "text",
          "name": "series_default_start_time",
          "visible": false,
          "defaultValue": "12:00"
        },
        {
          "type": "text",
          "name": "series_default_end_time",
          "visible": false,
          "defaultValue": "13:00"
        },
        {
          "type": "text",
          "name": "series_dates",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_day_modules",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_day_times",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_day_locations",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_same_time",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_same_location",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_same_modules",
          "visible": false,
          "readOnly": true,
          "defaultValue": "true"
        },
        {
          "type": "text",
          "name": "series_same_catering",
          "visible": false,
          "readOnly": true,
          "defaultValue": "true"
        },
        {
          "type": "text",
          "name": "series_default_catering",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_day_catering",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_default_module_ids",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "series_default_subtype_ids",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "schedule_inferred_mode",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "schedule_crosses_days",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "event_duration_type",
          "visible": false,
          "readOnly": true
        }
      ]
    },
    {
      "name": "page2",
      "title": "Moduler",
      "description": "",
      "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
      "visibilityDataSource": "event_modules_page_visible",
      "elements": [
        {
          "type": "panel",
          "name": "card_modules",
          "title": "Moduler",
          "cssClass": "duna-card duna-card--modules",
          "elements": [
            {
              "type": "infomodal",
              "name": "info_card_modules",
              "title": "Moduler",
              "titleLocation": "hidden",
              "modalTitle": "Moduler",
              "infoPartnerQuestion": "card_modules",
              "infoText": "<p>Vælg de moduler, eventet dækker. Brug de samme moduler som i de ønskede uddannelsesveje og kompetencer, så deltagernes fremdrift og kompetencer kan kobles til eventet.</p>",
              "startWithNewLine": true
            },
            {
              "type": "dualpanel",
              "name": "event_modules",
              "title": "Moduler",
              "titleLocation": "hidden",
              "width": "100%",
              "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
              "dataSource": "dual_panel_modules",
              "selectAllOnSearch": true
            }
          ]
        },
        {
          "type": "panel",
          "name": "event_subtypes_panel",
          "title": "Subtypes / Indholdstemaer (valgfrit)",
          "cssClass": "duna-card duna-card--subtypes duna-card--collapsible",
          "state": "collapsed",
          "visibleIf": "{schedule_mode} <> 'multi_dates' or {schedule_mode} empty",
          "elements": [
            {
              "type": "dualpanel",
              "name": "event_subtypes",
              "title": "Subtypes / Indholdstemaer",
              "titleLocation": "hidden",
              "width": "100%",
              "dataSource": "dual_panel_subtypes"
            }
          ]
        }
      ]
    },
    {
      "name": "page3",
      "title": "Indstillinger og pris",
      "description": "",
      "elements": [
        {
          "type": "panel",
          "name": "card_status",
          "title": "Status og synlighed",
          "cssClass": "duna-card duna-card--status",
          "elements": [
            {
              "type": "infomodal",
              "name": "info_event_active",
              "title": "Aktiv",
              "titleLocation": "hidden",
              "modalTitle": "Aktiv",
              "infoText": "<p><strong>Aktiv</strong>: Eventet er åbent og kan ses efter dets tilgængelighed.</p><p><strong>Inaktiv</strong>: Eventet er kun synligt for brugere i organisationen.</p>",
              "startWithNewLine": true
            },
            {
              "type": "radiogroup",
              "name": "event_active",
              "title": "Aktiv",
              "cssClass": "duna-segmented",
              "width": "20rem",
              "minWidth": "14rem",
              "colCount": 0,
              "defaultValue": "active",
              "choices": [
                {
                  "value": "active",
                  "text": "Aktiv"
                },
                {
                  "value": "inactive",
                  "text": "Inaktiv"
                }
              ]
            },
            {
              "type": "infomodal",
              "name": "info_is_shown",
              "title": "Synlighed",
              "titleLocation": "hidden",
              "modalTitle": "Synlighed",
              "infoText": "<p><strong>Synlig</strong>: Eventet vises i kalenderen og i oversigter.</p><p><strong>Skjult</strong>: Eventet vises ikke i oversigter og kan kun nås via et direkte link.</p>",
              "startWithNewLine": false
            },
            {
              "type": "radiogroup",
              "name": "is_shown",
              "title": "Synlighed",
              "cssClass": "duna-segmented",
              "width": "20rem",
              "minWidth": "14rem",
              "colCount": 0,
              "startWithNewLine": false,
              "defaultValue": "shown",
              "choices": [
                {
                  "value": "shown",
                  "text": "Synlig"
                },
                {
                  "value": "hidden",
                  "text": "Skjult"
                }
              ]
            },
            {
              "type": "infomodal",
              "name": "info_waitlist",
              "title": "Venteliste",
              "titleLocation": "hidden",
              "modalTitle": "Venteliste",
              "infoText": "<p>Vælg hvornår ventelisten skal benyttes.</p><p><strong>Benyt rum størrelse</strong>: Når lokalets kapacitet er nået, kommer nye tilmeldinger på venteliste.</p><p><strong>Alle på venteliste standard</strong>: Alle tilmeldinger starter på ventelisten, og du godkender dem manuelt.</p><p><strong>Deaktiver venteliste</strong>: Der er ingen venteliste, og tilmelding lukker, når eventet er fyldt.</p>",
              "startWithNewLine": true
            },
            {
              "type": "radiogroup",
              "name": "waitlist",
              "title": "Venteliste",
              "cssClass": "duna-segmented",
              "width": "100%",
              "colCount": 0,
              "startWithNewLine": true,
              "defaultValue": "room_size",
              "choices": [
                {
                  "value": "room_size",
                  "text": "Benyt rum størrelse"
                },
                {
                  "value": "everyone_on_wait_list",
                  "text": "Alle på venteliste standard"
                },
                {
                  "value": "no_wait_list",
                  "text": "Deaktiver venteliste"
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "course_price_panel",
          "visibleIf": "{event_type} = 'course'",
          "title": "Pris",
          "cssClass": "duna-card duna-card--price",
          "elements": [
            {
              "type": "infomodal",
              "name": "info_course_price_template_ids",
              "title": "Prisskabelon(er)",
              "titleLocation": "hidden",
              "modalTitle": "Prisskabelon(er)",
              "infoText": "<p>Vælg en eller flere prisskabeloner. Priserne fra de valgte skabeloner lægges sammen for den valgte prisgruppe og indtægtstype og danner kursets pris.</p>",
              "startWithNewLine": true
            },
            {
              "type": "tagbox",
              "name": "course_price_template_ids",
              "title": "Prisskabelon(er)",
              "placeholder": "Vælg skabeloner…",
              "width": "100%",
              "dataSource": "event_price_templates",
              "dataSourceKeyField": "label",
              "dataSourceValueField": "id",
              "searchEnabled": true,
              "allowClear": true
            },
            {
              "type": "infomodal",
              "name": "info_course_price_type",
              "title": "Kursustype",
              "titleLocation": "hidden",
              "modalTitle": "Kursustype",
              "infoText": "<p><strong>Internt kursus</strong>: Kurset er til egne medarbejdere og faktureres ikke eksternt.</p><p><strong>Indtægtsgivende</strong>: Kurset sælges til en kunde. Du vælger kunde, prisgruppe og indtægtstype nedenfor.</p>",
              "startWithNewLine": true
            },
            {
              "type": "radiogroup",
              "name": "course_price_type",
              "title": "Kursustype",
              "cssClass": "duna-segmented",
              "width": "100%",
              "colCount": 0,
              "isRequired": true,
              "choices": [
                {
                  "value": "internal",
                  "text": "Internt kursus"
                },
                {
                  "value": "revenue_generating",
                  "text": "Indtægtsgivende"
                }
              ]
            },
            {
              "type": "panel",
              "name": "course_revenue_group",
              "title": "Indtægtsgivende kursus",
              "cssClass": "duna-subgroup",
              "visibleIf": "{course_price_type} = 'revenue_generating'",
              "startWithNewLine": true,
              "elements": [
                {
                  "type": "infomodal",
                  "name": "info_customer_guid",
                  "title": "Kunde",
                  "titleLocation": "hidden",
                  "modalTitle": "Kunde",
                  "infoText": "<p>Vælg den kunde, der betaler for kurset, fra kundedatabasen. Findes kunden ikke, kan du oprette en ny.</p><p>Kundens prisgruppe bruges automatisk, hvis den er sat.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "startWithNewLine": true
                },
                {
                  "type": "dropdown",
                  "name": "customer_guid",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Kunde",
                  "placeholder": "Vælg kunde…",
                  "width": "20rem",
                  "minWidth": "12rem",
                  "dataSource": "customers",
                  "dataSourceKeyField": "name",
                  "dataSourceValueField": "guid",
                  "allowClear": true,
                  "allowCreate": true
                },
                {
                  "type": "infomodal",
                  "name": "info_course_price_group_id",
                  "title": "Prisgruppe",
                  "titleLocation": "hidden",
                  "modalTitle": "Prisgruppe",
                  "infoText": "<p>Bestemmer hvilke priser fra prisskabelonerne der bruges. Vælges automatisk ud fra kunden, hvis kunden har en prisgruppe, men kan ændres her.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "startWithNewLine": false
                },
                {
                  "type": "dropdown",
                  "name": "course_price_group_id",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Prisgruppe",
                  "placeholder": "Vælg prisgruppe…",
                  "width": "14rem",
                  "minWidth": "11rem",
                  "startWithNewLine": false,
                  "dataSource": "event_price_groups",
                  "dataSourceKeyField": "label",
                  "dataSourceValueField": "id",
                  "allowClear": true
                },
                {
                  "type": "html",
                  "name": "customer_guid_stamdata",
                  "visibleIf": "{course_price_type} = 'revenue_generating' and {customer_guid} notempty",
                  "width": "100%",
                  "startWithNewLine": true,
                  "html": "<div class=\"customer-guid-stamdata-panel\"></div>"
                },
                {
                  "type": "infomodal",
                  "name": "info_course_revenue_model",
                  "title": "Indtægtstype",
                  "titleLocation": "hidden",
                  "modalTitle": "Indtægtstype",
                  "infoText": "<p><strong>Fastsat beløb for kursus</strong>: Ét fast beløb for hele kurset, uanset antal deltagere.</p><p><strong>Per deltagelse per bruger</strong>: Prisen gælder for hver deltagelse pr. bruger og vokser med antallet af deltagere.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "startWithNewLine": true
                },
                {
                  "type": "radiogroup",
                  "name": "course_revenue_model",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Indtægtstype",
                  "cssClass": "duna-segmented",
                  "width": "100%",
                  "colCount": 0,
                  "startWithNewLine": true,
                  "requiredIf": "{course_price_type} = 'revenue_generating'",
                  "choices": [
                    {
                      "value": "fixed_course",
                      "text": "Fastsat beløb for kursus"
                    },
                    {
                      "value": "per_participant",
                      "text": "Per deltagelse per bruger"
                    }
                  ]
                },
                {
                  "type": "infomodal",
                  "name": "info_event_price",
                  "title": "Indtægt (kr.)",
                  "titleLocation": "hidden",
                  "modalTitle": "Indtægt (kr.)",
                  "infoText": "<p>Kursets indtægt i kroner. Udfyldes automatisk med summen af de valgte prisskabeloner, men kan redigeres manuelt.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "startWithNewLine": true
                },
                {
                  "type": "text",
                  "name": "event_price",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Indtægt (kr.)",
                  "width": "12rem",
                  "minWidth": "9rem",
                  "startWithNewLine": true,
                  "requiredIf": "{course_price_type} = 'revenue_generating'",
                  "defaultValue": 0,
                  "inputType": "number",
                  "min": 0
                },
                {
                  "type": "radiogroup",
                  "name": "course_extra_amount_enabled",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Tilføj ekstra beløb",
                  "cssClass": "duna-segmented duna-segmented--compact",
                  "width": "12rem",
                  "minWidth": "10rem",
                  "colCount": 0,
                  "startWithNewLine": false,
                  "defaultValue": "false",
                  "choices": [
                    {
                      "value": "false",
                      "text": "Nej"
                    },
                    {
                      "value": "true",
                      "text": "Ja"
                    }
                  ]
                },
                {
                  "type": "text",
                  "name": "course_extra_amount",
                  "visibleIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
                  "title": "Ekstra beløb (kr.)",
                  "width": "12rem",
                  "minWidth": "9rem",
                  "startWithNewLine": false,
                  "requiredIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
                  "defaultValue": 0,
                  "inputType": "number",
                  "min": 0
                },
                {
                  "type": "infomodal",
                  "name": "info_course_extra_amount_comment",
                  "title": "Kommentar til ekstra beløb",
                  "titleLocation": "hidden",
                  "modalTitle": "Kommentar til ekstra beløb",
                  "infoText": "<p>Beskriv hvad det fastsatte ekstra beløb dækker, så det er tydeligt ved fakturering.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
                  "startWithNewLine": true
                },
                {
                  "type": "comment",
                  "name": "course_extra_amount_comment",
                  "visibleIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
                  "title": "Kommentar til ekstra beløb",
                  "width": "100%",
                  "rows": 2,
                  "startWithNewLine": true,
                  "requiredIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'"
                },
                {
                  "type": "infomodal",
                  "name": "info_course_price_extras",
                  "title": "Price extras",
                  "titleLocation": "hidden",
                  "modalTitle": "Price extras",
                  "infoText": "<p>Ekstra tilvalg fra de valgte prisskabeloner. Angiv antal for hvert ekstra – standard er 0.</p>",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "startWithNewLine": true
                },
                {
                  "type": "paneldynamic",
                  "name": "course_price_extras",
                  "visibleIf": "{course_price_type} = 'revenue_generating'",
                  "title": "Price extras",
                  "cssClass": "duna-paneldynamic",
                  "width": "100%",
                  "startWithNewLine": true,
                  "panelCount": 0,
                  "confirmDelete": false,
                  "templateElements": [
                    {
                      "type": "dropdown",
                      "name": "extra_option_id",
                      "title": "Ekstra",
                      "placeholder": "Vælg ekstra…",
                      "width": "18rem",
                      "minWidth": "11rem",
                      "dataSource": "event_price_extra_options",
                      "dataSourceKeyField": "label",
                      "dataSourceValueField": "id"
                    },
                    {
                      "type": "text",
                      "name": "quantity",
                      "title": "Antal",
                      "width": "8rem",
                      "minWidth": "6rem",
                      "startWithNewLine": false,
                      "inputType": "number",
                      "min": 0,
                      "defaultValue": 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "card_catering_cta",
          "title": "Forplejning",
          "cssClass": "duna-card duna-card--catering",
          "visibleIf": "{catering} = 'lokation'",
          "elements": [
            {
              "type": "html",
              "name": "catering_wishes_launch",
              "visibleIf": "{catering} = 'lokation'",
              "width": "100%",
              "html": "<div class='duna-callout duna-callout--info event-catering-wishes-launch'><div class='duna-callout__body'><p class='duna-callout__title'>Forplejning — opretter begivenheden</p><p class='duna-callout__text'><strong>Vigtigt:</strong> Knappen <strong>«Opsæt forplejning»</strong> gemmer og <strong>opretter begivenheden med det samme</strong>, og du går direkte videre til forplejningsopsætning. Udfyld alle obligatoriske felter på alle synlige sider <strong>før</strong> du klikker (brug «Næste»/«Forrige»). Afslut formularen som normalt, hvis du ikke skal opsætte forplejning nu.</p></div><div class='duna-callout__actions'><button type='button' id='open-catering-wishes-btn' class='duna-btn duna-btn--outline'>Opsæt forplejning</button><p id='open-catering-wishes-hint' class='duna-callout__hint'>Klik kun når alle obligatoriske felter er udfyldt.</p></div></div>"
            }
          ]
        }
      ]
    }
  ],
  "navigationButtonsLocation": "bottom",
  "showTitle": true,
  "showCompletePage": false,
  "navigateToUrl": "/events",
  "checkErrorsMode": "onValueChanged",
  "dataSource": "event_form_data",
  "showEmptyFormSubmit": false
}
